export default "__VITE_ASSET__DcTz0P_j__"